// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore }from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAxVwsRgeDaWA33W7OA8zjNYt8PADt8bXw",
  authDomain: "vocabulario-app.firebaseapp.com",
  projectId: "vocabulario-app",
  storageBucket: "vocabulario-app.appspot.com",
  messagingSenderId: "290878573005",
  appId: "1:290878573005:web:88a472ebc5c59851bb5c84",
  measurementId: "G-65WNTXF8FS"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app)

export { db }